module.exports = __webpack_public_path__ + "static/media/1x2Gaming.0598443b.jpg";